
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <div className="flex items-center gap-2">
      <Link to="/" className="flex items-center gap-2">
        <img 
          src="/lovable-uploads/aad0c645-89f5-4dd6-bf0d-04384e55a2bf.png" 
          alt="Spharaka Logo" 
          className="h-8"
          width="197"
          height="32"
          loading="eager"
        />
      </Link>
    </div>
  );
};

export default Logo;
